import { render } from "./CatImpuestoForm.vue?vue&type=template&id=53787462&scoped=true"
import script from "./CatImpuestoForm.vue?vue&type=script&lang=js"
export * from "./CatImpuestoForm.vue?vue&type=script&lang=js"

import "./CatImpuestoForm.vue?vue&type=style&index=0&id=53787462&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53787462"]])

export default __exports__